"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = createController;
/**
 * Wrapps your controller with typescript autosuggestion + validation.
 */
function createController(controller) {
    return controller;
}
//# sourceMappingURL=createController.js.map